package com.mgacreative.hotel.core.network

import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.createSupabaseClient
import io.github.jan.supabase.auth.Auth
import io.github.jan.supabase.postgrest.Postgrest
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.asSharedFlow

import io.github.jan.supabase.realtime.Realtime

object NetworkConstants {
    const val SUPABASE_URL = "https://lgmbnguhakuidonawrkp.supabase.co"
    const val SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxnbWJuZ3VoYWt1aWRvbmF3cmtwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQ0ODMzMTAsImV4cCI6MjEwMDA1OTMxMH0.nb2EfdQJNlfFwibqJEm2SvbpCgeH3epaFBnM05oup14"
}

class SupabaseNetworkClient {
    
    private val persistentSessionManager = providePersistentSessionManager()

    val rememberableSessionManager: RememberableSessionManager?
        get() = persistentSessionManager as? RememberableSessionManager

    fun setRememberMe(remember: Boolean) {
        rememberableSessionManager?.rememberMe = remember
    }

    private val _networkErrors = MutableSharedFlow<Throwable>()
    val networkErrors = _networkErrors.asSharedFlow()

    val client: SupabaseClient by lazy {
        try {
            createSupabaseClient(
                supabaseUrl = NetworkConstants.SUPABASE_URL,
                supabaseKey = NetworkConstants.SUPABASE_ANON_KEY
            ) {
                install(Auth) {
                    alwaysAutoRefresh = true
                    autoLoadFromStorage = true
                    persistentSessionManager?.let { sm ->
                        sessionManager = sm
                    }
                }
                install(Postgrest)
                install(Realtime)
            }
        } catch (e: Throwable) {
            createSupabaseClient(
                supabaseUrl = NetworkConstants.SUPABASE_URL,
                supabaseKey = NetworkConstants.SUPABASE_ANON_KEY
            ) {
                install(Postgrest)
                install(Realtime)
            }
        }
    }
    
    suspend fun handleError(error: Throwable) {
        _networkErrors.emit(error)
    }
}
